import React, { useEffect, useState } from "react";
import styled from "styled-components";
import moment from "moment";

import { fetchUsers } from "../../../modules/presence/api/api";
import { Button, Table } from "antd";
import { FREQUENCY_ID, roles } from "../../../configs/constants";
import {
  bonusTypes,
  months,
  extractRegularBonus,
  extractExtraBonus,
  quarters,
  extractQuaterlyBonuses
} from "./BonusesHistory.utils";
import { SelectYearBonus } from "./SelectMonth.component";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const DEFAULT_START_DATE = moment().startOf("year");
const DETAULT_END_DATE = moment();

const BonusesHistory = ({ fetchBonuses, bonuses = [], clientId, clientLabel, token, roleId }) => {
  const [users, setUsers] = useState([]);
  const [areInactivesVisibles, setAreInactivesVisible] = useState(false);
  const [rangeDate, setRangeDate] = useState([DEFAULT_START_DATE, DETAULT_END_DATE]);

  const [selectedBonusType, setSelectedBonusType] = useState(bonusTypes[0]);

  const displayedUsers = areInactivesVisibles ? users : users.filter(u => u.effectif);
  const initUsers = async () => {
    try {
      const response = await fetchUsers(
        {
          match: { "clients.id": clientId, role_id: { $gt: roleId, $ne: roles.CLIENT } },
          sort: { email: 1 },
          project: { email: 1, effectif: 1 }
        },
        token
      );
      if (Array.isArray(response)) {
        setUsers(response);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    initUsers();
  }, [clientId]);

  useEffect(() => {
    const filters = {
      match: {
        $or: [{ "status.id": 2 }, { "status.id": 1 }],
        start_date: { $gte: { $date: rangeDate[0] } },
        "clients.id": clientId
      }
    };
    fetchBonuses(filters);
  }, [clientId, rangeDate]);
  const monthColumn = ({ title, monthNb }) => ({
    title,
    dataIndex: "_id",
    key: title,
    render: user_id => {
      if (selectedBonusType.frequency) {
        return <div className="flex items-center">{extractRegularBonus(bonuses, monthNb, user_id)}</div>;
      }
      return extractExtraBonus(bonuses, monthNb, user_id);
    }
  });
  const quarterColumn = ({ title, quarterNb }) => ({
    title,
    dataIndex: "_id",
    key: title,
    render: user_id => {
      if (selectedBonusType.frequency) {
        return <div className="flex items-center">{extractQuaterlyBonuses(bonuses, quarterNb, user_id)}</div>;
      }
    }
  });
  const monthsColumn = Array(12)
    .fill(0)
    .map((_, i) => monthColumn(months[i]));
  const quartersColumn = Array(4)
    .fill(0)
    .map((_, i) => quarterColumn(quarters[i]));
  const columns = [
    {
      title: "Utilisateur",
      dataIndex: "email",
      key: "email",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.email.localeCompare(b.email)
    }
  ].concat(selectedBonusType.frequency === FREQUENCY_ID.QUARTERLY ? quartersColumn : monthsColumn);

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        <div style={{ fontSize: 30, marginBottom: 100 }}>{`Primes ${
          selectedBonusType.label
        } du dossier ${clientLabel} pour ${moment(rangeDate[0]).format("YYYY")}`}</div>
      </div>
      <div>
        <SelectYearBonus setRangeDate={setRangeDate} rangeDate={rangeDate} />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
        <Button onClick={() => setAreInactivesVisible(v => !v)}>
          {areInactivesVisibles ? "cacher les inactifs" : "afficher les inactifs"}
        </Button>
        {bonusTypes.map(bT => (
          <Button onClick={() => setSelectedBonusType(bT)}>{bT.label}</Button>
        ))}
        <div></div>
      </div>

      <Table rowKey="_id" columns={columns} dataSource={displayedUsers} pagination={false} align="center" />
    </Container>
  );
};

export default BonusesHistory;



// WEBPACK FOOTER //
// src/containers/admin/premium/BonusesHistory.js